var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2211 0.721008C13.5132 1.0131 13.5132 1.48667 13.2211 1.77876L5.45711 9.54278C5.06658 9.9333 4.43342 9.9333 4.04289 9.54278L1.15407 6.65396C0.861874 6.36176 0.861874 5.88801 1.15407 5.59581V5.59581C1.44602 5.30386 1.91927 5.30357 2.21157 5.59516L4.75 8.12738L12.1636 0.720758C12.4558 0.428904 12.9291 0.429016 13.2211 0.721008V0.721008Z",
    fill: "#079E88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconGreen);
export default __webpack_public_path__ + "static/media/CheckIconGreen.3e5063bc6aadbb756621b8f6c4152893.svg";
export { ForwardRef as ReactComponent };